import {useAuth} from '@/libs/auth';
import {getModelSubscription} from '@/services/models-store';
import {useRouter} from 'next/router';
import {ReactElement, useEffect, useState} from 'react';
import BlackNav from "../general/nav/BlackNav";
import ModelNav from "../project/general/ModelNav";
import GeneralLayout from './GeneralLayout';
import BorderedNavbar from "@/components/general/nav/BorderedNavbar";
import DeploymentStatusNotifications from '../notifications/DeploymentStatusNotification';
import Footer from '../general/Footer';
import Head from 'next/head';
import {splitAndCapitalize} from '@/utils/general';
import StarterModelProvider from "../../contexts/StarterModelContext";

const ModelLayout = ({children}: any) => {
  const router = useRouter();
  const {loading, user} = useAuth();
  // ModelLayout is only used for models
  const {projectId, modelId} = router.query;
  const [model, setModel] = useState<any>();
  const [end, setEnd] = useState<any>("");
  const [showChildren, setShowChildren] = useState(false);

  useEffect(() => {
    if (!loading) {
      setShowChildren(true);
      getModelSubscription(projectId as string, modelId as string)
        .onSnapshot((value) => {
          const data = value.data()
          setModel(data);
        }, (e) => {
          if (user) {
            router.push('/dashboard');
          } else {
            router.push('/auth/signin');
          }
        })
    }
  }, [loading, modelId, projectId, router, user])

  useEffect(() => {
    const url = router.asPath.split('/').pop()
    setEnd(splitAndCapitalize(url as string, " "));
  }, [router]);

  return (
    <StarterModelProvider>
      {
        user ? <div className="pb-20">
          <BlackNav border={false}/>
        </div> : <BorderedNavbar/>
      }
      <Head>
        <title>{model?.name} / {end}</title>
      </Head>
      <ModelNav/>
      {
        showChildren ?
          (<main className="relative z-0 min-h-screen">{children}</main>) : null
      }
      {
        model?.lifecycleStatus && model?.lifecycleStatus?.message && model?.lifecycleStatus?.message !== 'Not Running' && model?.lifecycleStatus?.message !== 'Monitoring Active' && model?.lifecycleStatus?.message !== 'Awaiting Setup' && model?.lifecycleStatus?.message !== 'Exited' && model?.lifecycleStatus?.message !== 'Process Exited' && model?.lifecycleStatus?.message !== 'Stopped' ? (
          <DeploymentStatusNotifications name={model?.name} message={model?.lifecycleStatus?.message}/>
        ) : null
      }
      <Footer/>
    </StarterModelProvider>
  );
};

ModelLayout.getLayout = function getLayout(page: ReactElement) {
  return <GeneralLayout>{page}</GeneralLayout>;
};

export default ModelLayout;
